import { ActivityComponentType } from '@stackflow/react'
import { n_tutor_lists } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { TUTOR_TYPE } from '../../../modules/vars'
import { useTutorStack } from '../../../pages/[lang]/webview/tutors'
import TutorListBody from '../../student/new-portal/tutors/tutorListBody'
import WebviewStackContainer from '../common/WebviewStackContainer'

const TutorMainActivity: ActivityComponentType = ({ params }: { params?: { tab?: string } }) => {
  const { t } = useTranslation()
  const { useTutorFlow } = useTutorStack()
  const { pop } = useTutorFlow()
  return (
    <WebviewStackContainer height="54px" onBack={pop} title={t(n_tutor_lists.title)}>
      <TutorListBody type={params?.tab ? params.tab : TUTOR_TYPE.RECOMMEND_TUTOR} />
    </WebviewStackContainer>
  )
}

export default TutorMainActivity
